import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  cpr: PropTypes.object.isRequired,
};

const CprInfo = (props) => {
  return (
    <div className="info">
      <label>Care Plan Requirement (CPR) Information</label>
      CPR ID: <b>{props.cpr.id}</b>
      <br />
      Created at:{" "}
      <b>
        {new Date(props.cpr.created_at).toLocaleString([], {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        })}{" "}
      </b>
      <br />
      Code:<b> {props.cpr.code}</b>
      <br />
      Status:{" "}
      <b>
        {props.cpr.status &&
          props.cpr.status.replaceAll("-", " ").replaceAll("_", " ").toUpperCase()}
      </b>
      <br />
      Sub State:{" "}
      <b>
        {props.cpr.sub_status &&
          props.cpr.sub_status.replaceAll("-", " ").replaceAll("_", " ").toUpperCase()}
      </b>
      <br />
      Patient Response Status:{" "}
      <b>
        {props.cpr.cpr_type_response_status}
      </b>
      <br />
        Verified by Claims:{" "}
      <b>
        {props.cpr.verified_in_claims}
      </b>
      <br />
      <b>Extensions </b> <br />
      {!!props.cpr.extensions.length
        ? props.cpr.extensions.map(
            (i) =>
              i.patient_event_type == "extension" && (
                <b key={i.patient_event_type + i.created_at}>
                  <span className={"badge rounded-pill closed"}>
                    {new Date(i.created_at).toLocaleDateString()}
                  </span>{" "}
                </b>
              )
          )
        : "No extensions for this CPR"}
      <br />
    </div>
  );
};
CprInfo.prototype = propTypes;
export default CprInfo;
